import './Page.css';

function Page({children}) {

    return (
        <div className="page main">
            <div
                alt="AnyTech365 Compass AI"
                className="page-brand-watermark big-logo-anytech"
            />
            {children}
        </div>
    )
}

export default Page